import type { ReactNode } from 'react';

import { Box } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import PopupState, { bindPopper, bindToggle } from 'material-ui-popup-state';

import Button from '@/components/Buttons/Button';
import { Z_INDEX } from '@/constants/z-index';

import type { PopperPlacementType } from '@mui/material/Popper';
import type { SxProps, Theme } from '@mui/material/styles';

const paperSx: SxProps<Theme> = { zIndex: Z_INDEX.raised };

const CustomPopper = ({
  buttonContent,
  buttonVariant,
  children,
  disabled,
  sx,
  placement = 'auto',
  buttonStyles,
  modifiers,
  zIndex = Z_INDEX.floatingAnchor,
  closeOnClickInside
}: {
  buttonContent: ReactNode;
  buttonVariant: 'text' | 'outlined' | 'contained' | undefined;
  children: ReactNode;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  placement?: PopperPlacementType;
  buttonStyles?: SxProps<Theme>;
  modifiers?: any;
  zIndex?: number;
  closeOnClickInside?: boolean;
}) => {
  return (
    <PopupState
      popupId='demo-popup-popper'
      variant='popper'
    >
      {popupState => {
        const handleClose = () => {
          popupState.close();
        };

        return (
          <Box sx={sx}>
            <Button
              disabled={disabled}
              size='small'
              sx={buttonStyles}
              variant={buttonVariant}
              {...bindToggle(popupState)}
            >
              {buttonContent}
            </Button>
            <Popper
              modifiers={modifiers}
              style={{ zIndex }}
              {...bindPopper(popupState)}
              transition
              placement={placement}
            >
              {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                  <Paper sx={paperSx}>
                    <ClickAwayListener
                      mouseEvent='onMouseDown'
                      onClickAway={handleClose}
                    >
                      <Box onClick={closeOnClickInside ? handleClose : undefined}>{children}</Box>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        );
      }}
    </PopupState>
  );
};

export default CustomPopper;
